// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import { frontmatter as fm0, toc as t0 } from '/vercel/path0/docs/demo/multiple-Portal.md?type=frontmatter';
import { demoIndex as dmi0 } from '/vercel/path0/docs/demo/multiple-Portal.md?type=demo-index';
import { frontmatter as fm1, toc as t1 } from '/vercel/path0/docs/demo/with-portal.md?type=frontmatter';
import { demoIndex as dmi1 } from '/vercel/path0/docs/demo/with-portal.md?type=demo-index';
import { frontmatter as fm2, toc as t2 } from '/vercel/path0/docs/demo/ant-design.md?type=frontmatter';
import { demoIndex as dmi2 } from '/vercel/path0/docs/demo/ant-design.md?type=demo-index';
import { frontmatter as fm3, toc as t3 } from '/vercel/path0/docs/demo/bootstrap.md?type=frontmatter';
import { demoIndex as dmi3 } from '/vercel/path0/docs/demo/bootstrap.md?type=demo-index';
import { frontmatter as fm4, toc as t4 } from '/vercel/path0/docs/demo/draggable.md?type=frontmatter';
import { demoIndex as dmi4 } from '/vercel/path0/docs/demo/draggable.md?type=demo-index';
import { frontmatter as fm5, toc as t5 } from '/vercel/path0/docs/changelog.md?type=frontmatter';
import { demoIndex as dmi5 } from '/vercel/path0/docs/changelog.md?type=demo-index';
import { frontmatter as fm6, toc as t6 } from '/vercel/path0/docs/demo/pure.md?type=frontmatter';
import { demoIndex as dmi6 } from '/vercel/path0/docs/demo/pure.md?type=demo-index';
import { frontmatter as fm7, toc as t7 } from '/vercel/path0/docs/index.md?type=frontmatter';
import { demoIndex as dmi7 } from '/vercel/path0/docs/index.md?type=demo-index';

export const filesMeta = {
  'docs/demo/multiple-Portal': {
    frontmatter: fm0,
    toc: t0,
    demoIndex: dmi0,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/multiple-Portal.md?type=text'),
  },
  'docs/demo/with-portal': {
    frontmatter: fm1,
    toc: t1,
    demoIndex: dmi1,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/with-portal.md?type=text'),
  },
  'docs/demo/ant-design': {
    frontmatter: fm2,
    toc: t2,
    demoIndex: dmi2,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/ant-design.md?type=text'),
  },
  'docs/demo/bootstrap': {
    frontmatter: fm3,
    toc: t3,
    demoIndex: dmi3,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/bootstrap.md?type=text'),
  },
  'docs/demo/draggable': {
    frontmatter: fm4,
    toc: t4,
    demoIndex: dmi4,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/draggable.md?type=text'),
  },
  'docs/changelog': {
    frontmatter: fm5,
    toc: t5,
    demoIndex: dmi5,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/changelog.md?type=text'),
  },
  'docs/demo/pure': {
    frontmatter: fm6,
    toc: t6,
    demoIndex: dmi6,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/pure.md?type=text'),
  },
  'docs/index': {
    frontmatter: fm7,
    toc: t7,
    demoIndex: dmi7,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/index.md?type=text'),
  },
}

export { tabs as tabsMeta } from './tabs';
